import axios from '@/plugins/axiosInstance'
import { settings } from '@/networking/urlManager'

/**
 * Deletes a category
 * @param {string|number} categoryId - The category ID to delete
 * @param {string|number} assetId - The asset ID
 * @returns {Promise<Object>} - The API response
 */
export const deleteCategory = async (categoryId, assetId) => {
  try {
    const response = await axios.put(settings.deleteCategory, {
      id: categoryId,
      assetId,
    })
    return ({
      success: true,
      data: response.data,
      status: response.status,
    })
  } catch (error) {
    console.error('Error deleting category:', error)
    throw error
  }
}
